














































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundModalTracking extends Vue {
  @Prop() readonly trackingList!: any;

  @Prop() readonly modalType!: any;

  @Prop() readonly modalState!: any;

  @Prop() readonly checkStatusRound!: Function;

  utilsInstance = utils;

  nameType = ''

  created() {
    this.nameType = this.modalType.split('_');
    this.nameType = this.nameType[0].toLowerCase();
  }

  checkAxios(key) {
    return this.trackingList[0].axiosData[this.nameType].request[0][key]
      ? this.trackingList[0].axiosData[this.nameType].request[0][key]
      : '-';
  }

  checkAxiosStatus(key) {
    return (this.trackingList[0].axiosData[this.nameType].response[0].status[key]).toString()
      ? this.trackingList[0].axiosData[this.nameType].response[0].status[key]
      : '-';
  }

  checkAxiosBalance(key) {
    return this.trackingList[0].axiosData[this.nameType].response[0].data.balance
      && this.trackingList[0].axiosData[this.nameType].response[0].data.balance[key]
      ? this.trackingList[0].axiosData[this.nameType].response[0].data.balance[key]
      : '-';
  }

  checkAxiosResponse(key) {
    return this.trackingList[0].axiosData[this.nameType].response[0].data[key]
      ? this.trackingList[0].axiosData[this.nameType].response[0].data[key]
      : '-';
  }
}
